const edgeMarketsState = {
    edgeMarkets: undefined,
    requestingEdgeMarkets: false
};
export default edgeMarketsState;
